
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"36.382","height":"36.381"}},[_c('path',{attrs:{"d":"M35.882 18.19A17.691 17.691 0 1118.191.5a17.69 17.69 0 0117.691 17.69","fill":"#5686f6","stroke":"#006aff"}}),_c('text',{attrs:{"transform":"translate(18 22)","fill":"#fff","font-size":"10","font-family":"Poppins"}},[_c('tspan',{attrs:{"x":"-11.195","y":"0"}},[_vm._v("SMS")])])]);
        };
      

        module.exports = {
          
          render: render,
        };
      